namespace Ir.Components.Workbook.WorkbookContainer {
    interface IWorkbookContainerViewModel {
        //splitterConfig: DevExpress.ui.dxSplitter.Properties;
        config: WorkbookConfig,
        isMobile: boolean;
        drawerConfig: DevExpress.ui.dxDrawer.Properties;
    }

    export function getViewModel(this: IWorkbookContainerViewModel, params: any, componentInfo) {
        let self = this;
        let config = params.config as WorkbookConfig;
        self.config = config;

        self.isMobile = isMobile();

        //self.splitterConfig = {
        //    height: "100%",
        //    separatorSize: 8,
        //    orientation: "horizontal",
        //    items: [
        //        {
        //            collapsible: true,
        //            collapsedSize: 20,
        //            minSize: 20,
        //            size: 250,
        //            template() {
        //                let $element = $(`<workbooksidetabs params="config: $data"></workbooksidetabs>"`);
        //                ko.applyBindings(config, $element[0]);
        //                return $element;
        //            },
        //        },
        //        {
        //            template() {
        //                let $element = $(`<workbooktabs params="config: $data"></workbooktabs>`);
        //                ko.applyBindings(config, $element[0]);
        //                return $element;
        //            },
        //        }
        //    ],
        //}
        let drawerCookieName = `ir-drawer-opened-u${loggedUser.id()}`;
        let hideSidebarWhenOpening = workbook.workbookConfig.preferences.hideSidebarWhenOpening() ? false : true;
        if (!workbook.workbookConfig.reloadManually) {
            CookieService.set(drawerCookieName, hideSidebarWhenOpening);
        }
        
        self.drawerConfig = {
            openedStateMode: isMobile() ? "overlap" : "shrink",
            revealMode: "slide",
            opened: isMobile() ? false : workbook.workbookConfig.reloadManually ? CookieService.get(drawerCookieName, hideSidebarWhenOpening) : hideSidebarWhenOpening,
            closeOnOutsideClick: isMobile(),
            height: "100%",
            template() {
                let $element = $(`<workbooksidetabs params="config: $data" style="display: flex; width: 285px; background-color: white;"></workbooksidetabs>"`);
                ko.applyBindings(config, $element[0]);
                return $element;
            },
            onInitialized(e) {
                self.config.generalSettings.drawerWorkbookSideBars = e.component;
            },
            onOptionChanged(e) {
                if (e.fullName === "opened") {
                    CookieService.set(drawerCookieName, e.value);
                }
            }
        };

        //https://knockoutjs.com/documentation/binding-lifecycle-events.html
        // (ko as any).bindingEvent.subscribe(componentInfo.element, 'descendantsComplete', function (node) {
        //     // You can add custom post-processing logic here
        //     workbook.workbookConfig.callIntroForEmpty();    
        // }.bind(this));
    }
}